export const BASE_ADMIN_API_URI = process.env.REACT_APP_ADMIN_API_URL;
